###
MarketoOverridesVM - provides some custom methods to remove inline styles in
Marketo sourced forms
###
window.MarketoOverridesVM = ->
  self = this
  self.root = undefined
  self.form = undefined

  self.findForm = ->
    self.form = self.root.find('form.mktoForm')

  self.removeButtonWrap = ->
    buttonWrap = self.root.find('.mktoButtonWrap')

    buttonWrap.removeAttr('style')

  self.useBootstrapDatepicker = (elem) ->
    self.findForm() if not self.form
    self.form.find(elem).pickadate
      autoclose: true
      format: 'dd/mm/yyyy'
      formatSubmit: 'yyyy-mm-dd'
      selectYears: true
      selectMonths: true
      min: -30
      max: 365

  self.hideForms = ->
    self.root.append(
      $('<style id="mktohide">.mktoForm { display: none !important;}</style>')
    )

  self.showForms = ->
    self.root.find('#mktohide').remove()

  self.nukeBaseStyle = ->
    self.form.removeAttr('style')
    self.form.children('style').remove()
    self.form.find('.mktoField').removeAttr('style')
    $('#mktoForms2BaseStyle,#mktoForms2ThemeStyle').remove()

  self.applyBindings = (elem) ->
    self.root = elem
    self.hideForms()

  return
